<template>
  <v-dialog v-model="isOpen" max-width="1000px">
    <template v-slot:activator="{ on }">
      <v-btn v-bind="$attrs" v-on="on" @click="click">
        <slot name="dialog-button-text"> </slot>
      </v-btn>
    </template>

    <slot name="dialog-form"> </slot>
  </v-dialog>
</template>

<script>
export default {
  name: "EditItemDialogButton",
  data: () => ({
    isOpen: false,
  }),
  methods: {
    open() {
      this.isOpen = true;
    },
    close() {
      this.isOpen = false;
    },
    click() {
      this.$emit("click");
    },
  },
};
</script>
